import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = "21626677428"; // Votre numéro sans le +

  const handleSendMessage = () => {
    const message = encodeURIComponent("Hello MM2A, I have a question about your olive oil.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-[9999] font-sans">
      {/* Fenêtre de Chat */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 transition-all transform scale-100 origin-bottom-right">
          {/* Header */}
          <div className="bg-[#075e54] p-4 text-white flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <MessageCircle size={24} />
              </div>
              <div>
                <p className="font-bold text-sm">MM2A Support</p>
                <p className="text-[10px] opacity-80">Typically replies in minutes</p>
              </div>
            </div>
            <button onClick={() => setIsOpen(false)} className="hover:bg-white/10 rounded-full p-1">
              <X size={20} />
            </button>
          </div>

          {/* Corps du message */}
          <div className="p-6 bg-[#e5ddd5] min-h-[100px]">
            <div className="bg-white p-3 rounded-lg rounded-tl-none shadow-sm relative inline-block max-w-[90%]">
              <p className="text-sm text-gray-800">
                Hi there! 👋 <br />
                How can we help you with your olive oil inquiry today?
              </p>
              <span className="text-[9px] text-gray-400 absolute bottom-1 right-2">
                {new Date().getHours()}:{new Date().getMinutes()}
              </span>
            </div>
          </div>

          {/* Footer / Bouton d'action */}
          <div className="p-4 bg-white">
            <button 
              aria-label="Contact us on WhatsApp"
              onClick={handleSendMessage}
              className="w-full bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-2 px-4 rounded-full flex items-center justify-center gap-2 transition-colors"
            >
              <Send size={18} />
              Start Chat
            </button>
          </div>
        </div>
      )}

      {/* Bulle Flottante (Le bouton principal) */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`${
          isOpen ? 'bg-gray-500' : 'bg-[#25D366]'
        } text-white p-4 rounded-full shadow-lg hover:scale-110 transition-all duration-300 flex items-center justify-center`}
      >
        {isOpen ? <X size={30} /> : <MessageCircle size={30} />}
        
        {/* Notification Badge (Optionnel) */}
        {!isOpen && (
          <span className="absolute top-0 right-0 flex h-4 w-4">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 border-2 border-white"></span>
          </span>
        )}
      </button>
    </div>
  );
};

export default WhatsAppWidget;